<template>
  <div class="config">
	  <div class="form-group row">
      <div class="col">
        <label for="user">Host</label>
        <input v-model="host" type="text" class="form-control" id="host">
      </div>
      <div class="col">
        <label for="user">User</label>
        <input v-model="user" type="text" class="form-control" id="user">
      </div>
      <div class="col">
        <label for="password">Password</label>
        <input v-model="password" type="password" class="form-control" id="password">
      </div>
      <div class="col col-md-auto">
        <button @click="updateConfig()" type="button" class="btn btn-primary">Update</button>
      </div>
	  </div>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'ApiConfig',
  data () {
    return {
      host: '',
      user: '',
      password: ''
    }
  },
  created () {
    // load existing config from localStorage if present
    if (this.$store.dispatch('fetchApiConfigFromLocalStorage')) {
      this.host = this.$store.state.api.host
      this.user = this.$store.state.api.user
      this.password = this.$store.state.api.password
    }
  },
  methods: {
    updateConfig () {
      this.$store.commit('setHost', this.host)
      this.$store.commit('setUser', this.user)
      this.$store.commit('setPassword', this.password)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.config {
  margin-top: 1rem;
  margin-bottom: 2rem;
}
.config .form-group {
  align-items: flex-end;
}
</style>



// WEBPACK FOOTER //
// ApiConfig.vue?f7399230